export const claimsRequestStatusMap: Record<string, string[]> = {
  all: ['APPROVED', 'PARTIALLY_APPROVED', 'REJECTED', 'PENDING'],
  approved: ['APPROVED', 'PARTIALLY_APPROVED'],
  rejected: ['REJECTED'],
  pending: ['PENDING'],
};

export const completedClaimsStatusFilters = {
  all: 'All Requests',
  approved: 'Approved',
  rejected: 'Rejected',
} as const;

export const completedStatusFilters = {
  approved_claims: 'Approved Claims',
  rejected_claims: 'Rejected Claims',
  approved_by_me: 'Approved By Me',
  rejected_by_me: 'Rejected By Me',
} as const;

export const completedStatusMap: Record<string, { status: string[]; includeUserId: boolean }> = {
  approved_claims: { status: ['APPROVED', 'PARTIALLY_APPROVED'], includeUserId: false },
  rejected_claims: { status: ['REJECTED'], includeUserId: false },
  approved_by_me: { status: ['APPROVED', 'PARTIALLY_APPROVED'], includeUserId: true },
  rejected_by_me: { status: ['REJECTED'], includeUserId: true },
};

export const datePresets = [
  {
    label: 'Last 7 days',
    value: (today: Date): [Date, Date] => {
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      return [sevenDaysAgo, today];
    },
  },
  {
    label: 'Last 30 days',
    value: (today: Date): [Date, Date] => {
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      return [thirtyDaysAgo, today];
    },
  },
  {
    label: 'This month',
    value: (today: Date): [Date, Date] => {
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return [firstDayOfMonth, today];
    },
  },
];
